import jQuery from "jquery";
import map from './map';
import getLocation from './location';
import { Loader } from "@googlemaps/js-api-loader"

const input = document.getElementById('location');
(function ($) {
	if( ! input ) {
		return
	}
	const loader = new Loader(
		{
			apiKey: `${acf_option.google_api_key}`,
			libraries: ["places"]
		}
	);

	loader
		.load()
		.then(
			() => {
				let autocomplete;
				autocomplete = new google.maps.places.Autocomplete(input, {
					types:['geocode'],
				})

			}
		)
		.catch( error => console.error( error ) )

	$( ".-js-get-location" ).click(
		function () {
			getLocation( showPosition );
		}
	);

	function showPosition(position) {

		let lat = position.coords.latitude;
		let lng = position.coords.longitude;

		$.get(
			`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${acf_option.google_api_key}&ver=1623319620`,
			function(data) {
				$( ".-js-set-location" ).val( data.results[0].formatted_address );
				$( ".-js-search-cpt" ).click();
			}
		)
	}

	$( document ).on(
		"click",
		".-js-search-cpt",
		function (e) {
			e.preventDefault();
			let form = e.target.closest( "form" );

			$.ajax(
				{
					method: "POST",
					url: ajaxurl,
					data: $( form ).serializeArray(),
				}
			).done(
				function (data) {
					$( ".-js-append-search-rows" ).html( data );
					$( ".search-relative" ).addClass( "was-searched" );
					let destination = $( form ).serializeArray()
					map( destination );
					$('.seller-type').find('input').each(function () {
						this.checked = false;
					})

					// Sort Results
					setTimeout(
						function() {
							var wrapper = $( '.-js-append-search-rows' );
							wrapper.find( '.search-result.sort' ).sort(
								function (a, b) {
									return +a.dataset.distance - +b.dataset.distance;
								}
							).appendTo( wrapper );
						},
						1000
					)

				}
			);

		}
	);

})( jQuery );
